import fetchLoyaltyConfig from 'actions/loyalty/fetchLoyaltyConfig'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useLoyaltyConfig(): [App.LoyaltyConfig | undefined, boolean, any] {
  const dispatch = useAppDispatch()

  const config = useAppSelector(state => state.loyalty.config)
  const fetching = useAppSelector(state => state.loyalty.fetchingConfig)
  const error = useAppSelector(state => state.loyalty.configError)

  useEffect(() => {
    dispatch(fetchLoyaltyConfig())
  }, [dispatch])

  return [
    config,
    !!fetching,
    error,
  ]
}

export default useLoyaltyConfig
